import * as yup from 'yup'

/**
|--------------------------------------------------
| Initial Values
|--------------------------------------------------
*/
export const signupInitialValues = () => {
  const values = {
    password: '',
    confirmPassword: ''
  }

  return values
}

/**
|--------------------------------------------------
| Schema
|--------------------------------------------------
*/
export const signupValidationSchema = yup.object().shape({
  password: yup
    .string()
    .min(6, '*Must long at least 6 characters')
    .required(`*Required.`),
  confirmPassword: yup.string().required(`*Required.`)
})

/**
|--------------------------------------------------
| Custom Validations
|--------------------------------------------------
*/
export function validateConfirmPassword(confirmPassword, password) {
  if (confirmPassword !== password) {
    return `*Confirm password must equal password.`
  }
}
